import styled from 'styled-components';

export const Wrapper = styled.div`
  gap: 16px;
  margin: 16px 15px;
  height: auto;
`;

export const EmptyText = styled.div`
  justify-content: center;
  text-align: center;
  margin: 16px 15px;
`;
